import React, { useCallback, useEffect, useState } from 'react'
import { ModalMedium } from '../../../../../../../../../../baseComponents/Modal'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import ModalCEShippingForm from './STSRCSZForm'
import ModalCEShippingTable from './STSRCSZTable'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { ShippingZoneGroupModelType } from '@teinor/erp/types/company/config/shipping/shippingZoneGroup'

interface ModalCreateShippingZonesServiceProps extends ModalEditComponentPropsWithoutSubmit {
    getAllData: () => Promise<void>
}

const ModalCreateShippingZonesService: React.FC<ModalCreateShippingZonesServiceProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { setData, data } = useModalCreateShippingZonesServiceLogic({ allRowData: allRowData || {} })
    return (
        <ModalMedium opened={true} setOpened={rest.setOpened} className='flex flex-col '>
            <ModalCEShippingForm setData={setData} data={data} />
            <ModalCEShippingTable data={data} setData={setData} allRowData={allRowData || {}} {...rest} />
        </ModalMedium>
    )
}

interface ModalCreateShippingZonesServiceLogicProps {
    allRowData: RowData
}

const useModalCreateShippingZonesServiceLogic = ({ allRowData }: ModalCreateShippingZonesServiceLogicProps) => {
    const [data, setData] = useState<ShippingZoneGroupModelType>({ id: 0, name: '', ShippingZones: [] })
    const getAllShippingZones = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/config/shipping/shippingZone/getShippingZoneInstanceComplete', { id: allRowData?.id })
        if (result) {
            setData(result)
        }
    }, [setData, allRowData?.id])

    useEffect(() => {
        if (allRowData?.id) {
            getAllShippingZones()
        }
    }, [getAllShippingZones, allRowData.id])

    return {data, setData}
}


export default ModalCreateShippingZonesService